import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CONTACT } from "@/data/site";
import useSEO from "@/hooks/useSEO";

export default function PrivacyPolicy() {
  useSEO({
    title: "Politique de confidentialité — OKA VTC",
    description: "Politique de confidentialité et protection des données personnelles d'OKA VTC, chauffeur privé VTC à Lyon.",
  });

  return (
    <div data-testid="privacy-page" className="min-h-screen bg-[#F8F9FA] text-[#0B132B]">
      <div className="mx-auto max-w-3xl px-6 md:px-12 py-16 md:py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#1C2541]/60 hover:text-[#0B132B] transition-colors duration-300 mb-10"
        >
          <ArrowLeft className="w-4 h-4" /> Retour au site
        </Link>

        <h1 className="font-display text-4xl md:text-5xl tracking-tight mb-2">
          Politique de confidentialité
        </h1>
        <p className="text-[#1C2541]/50 text-sm mb-12">Dernière mise à jour : juillet 2026</p>

        <div className="space-y-10 text-[#1C2541]/80 leading-relaxed">
          <section>
            <h2 className="font-display text-xl text-[#0B132B] mb-3">Responsable du traitement</h2>
            <p>
              {CONTACT.brand}, chauffeur privé indépendant en {CONTACT.zone}, est responsable du
              traitement des données personnelles collectées via ce site.
              Contact : <a href={`mailto:${CONTACT.email}`} className="underline hover:text-[#0B132B]">{CONTACT.email}</a> — {CONTACT.phoneDisplay}.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0B132B] mb-3">Données collectées</h2>
            <p className="mb-2">Lorsque vous utilisez le formulaire de réservation, nous collectons :</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Votre nom et numéro de téléphone</li>
              <li>Votre adresse email (facultative)</li>
              <li>Le lieu de départ et de destination</li>
              <li>La date, l'heure et le nombre de passagers</li>
              <li>Tout message complémentaire que vous saisissez</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0B132B] mb-3">Finalité et base légale</h2>
            <p>
              Ces données sont utilisées exclusivement pour traiter votre demande de réservation
              et vous recontacter à ce sujet. Le traitement repose sur l'exécution de mesures
              précontractuelles prises à votre demande (article 6.1.b du RGPD).
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0B132B] mb-3">Destinataires et hébergement</h2>
            <p>
              Vos données ne sont ni vendues ni partagées avec des tiers à des fins commerciales.
              Elles sont stockées de façon sécurisée chez MongoDB Atlas et l'email de confirmation
              vous est envoyé via le prestataire Resend, uniquement pour les besoins du service.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0B132B] mb-3">Durée de conservation</h2>
            <p>
              Vos données de réservation sont conservées le temps nécessaire au traitement de
              votre demande, puis jusqu'à 3 ans à des fins de suivi commercial, sauf demande de
              suppression anticipée de votre part.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0B132B] mb-3">Cookies</h2>
            <p>
              Ce site n'utilise aucun cookie de suivi, de mesure d'audience ou publicitaire. Aucune
              donnée de navigation n'est transmise à des tiers à des fins d'analyse ou de ciblage.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0B132B] mb-3">Vos droits</h2>
            <p>
              Conformément au RGPD, vous disposez d'un droit d'accès, de rectification,
              d'effacement, de limitation et d'opposition concernant vos données personnelles.
              Pour exercer ces droits, contactez-nous à{" "}
              <a href={`mailto:${CONTACT.email}`} className="underline hover:text-[#0B132B]">{CONTACT.email}</a>.
              Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
